(function () {
  'use strict';

  var DURATION = 380;
  var EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function getClosedHeight(details) {
    var summary = details.querySelector('.faq-page__question');
    if (!summary) return details.offsetHeight;

    var style = window.getComputedStyle(details);
    var padding =
      parseFloat(style.paddingTop) + parseFloat(style.paddingBottom);

    return summary.offsetHeight + padding;
  }

  function resetInlineStyles(details) {
    details.style.height = '';
    details.style.overflow = '';
    details.style.transition = '';
    details.classList.remove('is-animating');
    details.dataset.animating = 'false';
  }

  function animateHeight(details, startHeight, endHeight) {
    if (prefersReducedMotion()) {
      resetInlineStyles(details);
      return Promise.resolve();
    }

    return new Promise(function (resolve) {
      var finished = false;

      function finish() {
        if (finished) return;
        finished = true;
        details.removeEventListener('transitionend', onTransitionEnd);
        resetInlineStyles(details);
        resolve();
      }

      function onTransitionEnd(event) {
        if (event.target !== details || event.propertyName !== 'height') return;
        finish();
      }

      details.dataset.animating = 'true';
      details.classList.add('is-animating');
      details.style.overflow = 'hidden';
      details.style.height = startHeight + 'px';
      details.style.transition = 'none';
      details.offsetHeight;

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          details.style.transition = 'height ' + DURATION + 'ms ' + EASING;
          details.style.height = endHeight + 'px';
        });
      });

      details.addEventListener('transitionend', onTransitionEnd);
      window.setTimeout(finish, DURATION + 80);
    });
  }

  function closeItem(details) {
    if (!details || !details.hasAttribute('open')) {
      return Promise.resolve();
    }

    if (details.dataset.animating === 'true') {
      resetInlineStyles(details);
    }

    var startHeight = details.offsetHeight;
    var endHeight = getClosedHeight(details);

    return animateHeight(details, startHeight, endHeight).then(function () {
      details.removeAttribute('open');
      details.classList.remove('is-expanded');
    });
  }

  function openItem(details) {
    if (!details || details.hasAttribute('open')) {
      return Promise.resolve();
    }

    var startHeight = getClosedHeight(details);

    details.setAttribute('open', '');
    details.classList.add('is-expanded');

    var endHeight = details.scrollHeight;

    details.style.height = startHeight + 'px';
    details.style.overflow = 'hidden';

    return animateHeight(details, startHeight, endHeight);
  }

  function getOpenItems(scope) {
    return Array.prototype.slice.call(
      scope.querySelectorAll('.faq-page__item[open], .faq-page__item.is-expanded')
    );
  }

  function handleToggle(details, section) {
    if (section.dataset.faqBusy === 'true') return;

    var list = details.closest('.faq-page__list');
    if (!list) return;

    var isOpen =
      details.hasAttribute('open') || details.classList.contains('is-expanded');

    section.dataset.faqBusy = 'true';

    var sequence = Promise.resolve();

    if (isOpen) {
      sequence = closeItem(details);
    } else {
      var openItems = getOpenItems(list).filter(function (item) {
        return item !== details;
      });

      openItems.forEach(function (openItem) {
        sequence = sequence.then(function () {
          return closeItem(openItem);
        });
      });

      sequence = sequence.then(function () {
        return openItem(details);
      });
    }

    sequence
      .catch(function () {})
      .then(function () {
        section.dataset.faqBusy = 'false';
      });
  }

  function linkifyEmailsInTextNode(textNode) {
    var emailPattern = /\b([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})\b/g;
    var text = textNode.nodeValue;
    var matches = [];
    var match;

    while ((match = emailPattern.exec(text)) !== null) {
      matches.push({
        email: match[1],
        index: match.index,
        length: match[0].length
      });
    }

    if (!matches.length) return;

    var fragment = document.createDocumentFragment();
    var lastIndex = 0;

    matches.forEach(function (item) {
      if (item.index > lastIndex) {
        fragment.appendChild(document.createTextNode(text.slice(lastIndex, item.index)));
      }

      var link = document.createElement('a');
      link.href = 'mailto:' + item.email;
      link.textContent = item.email;
      fragment.appendChild(link);
      lastIndex = item.index + item.length;
    });

    if (lastIndex < text.length) {
      fragment.appendChild(document.createTextNode(text.slice(lastIndex)));
    }

    textNode.parentNode.replaceChild(fragment, textNode);
  }

  function linkifyEmailsInAnswers(section) {
    var emailTest = /\b[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}\b/;

    section.querySelectorAll('.faq-page__answer').forEach(function (answer) {
      var textNodes = [];
      var walker = document.createTreeWalker(answer, NodeFilter.SHOW_TEXT);
      var node;

      while ((node = walker.nextNode())) {
        if (!node.nodeValue || !emailTest.test(node.nodeValue)) continue;
        if (node.parentElement && node.parentElement.closest('a')) continue;
        if (node.parentElement && /^(SCRIPT|STYLE)$/i.test(node.parentElement.tagName)) continue;
        textNodes.push(node);
      }

      textNodes.forEach(linkifyEmailsInTextNode);
    });
  }

  function normalizeAnswerLinks(section) {
    section.querySelectorAll('.faq-page__answer a[href]').forEach(function (link) {
      var href = link.getAttribute('href') || '';

      if (href.indexOf('mailto:') === 0) {
        link.removeAttribute('target');
        link.removeAttribute('rel');
      }

      link.addEventListener('click', function (event) {
        event.stopPropagation();
      });
    });
  }

  function prepareItem(details) {
    var summary = details.querySelector('.faq-page__question');
    if (!summary) return;

    details.dataset.animating = 'false';

    if (details.hasAttribute('open')) {
      details.classList.add('is-expanded');
    }

    summary.addEventListener('click', function (event) {
      event.preventDefault();
      var section = details.closest('.faq-page');
      if (!section) return;
      handleToggle(details, section);
    });
  }

  function initSection(section) {
    if (!section || section.dataset.faqPageInit === 'true') return;
    section.dataset.faqPageInit = 'true';
    section.dataset.faqBusy = 'false';

    linkifyEmailsInAnswers(section);
    normalizeAnswerLinks(section);
    section.querySelectorAll('.faq-page__item').forEach(prepareItem);
  }

  function initAll() {
    document.querySelectorAll('.faq-page').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.faq-page');
    if (section) initSection(section);
  });
})();
